/** Renewal screen paths, in flow order. Routed as `/${basePath}${route}`. */
export enum RenewRoute {
  Intro = "/intro",
  ConfirmRate = "/rate",
  Success = "/success",
  NoOffers = "/no-offers",
}
